import WalletDetailHeader from './WalletDetailHeader'
import WalletDetailList from './WalletDetailList'
import WalletDetailListItem from './WalletDetailListItem'
import WalletNewInfo from './WalletNewInfo'
import WalletNewHeader from './WalletNewHeader'
import WalletIapBalance from './WalletIapBalance'
import WalletIapRechargeOption from './WalletIapRechargeOption'

export {
    WalletDetailHeader,
    WalletDetailList,
    WalletDetailListItem,
    WalletNewInfo,
    WalletNewHeader,
    WalletIapBalance,
    WalletIapRechargeOption
}


// WEBPACK FOOTER //
// ./src/components/wallet/index.js